import buildParams from 'ha/utils/buildParams';
import prepareFormData from 'ha/utils/prepareFormData';
import { RequestError, ApiError } from './errors';
import handleApiV2Response from './handleApiV2Response';

interface FetchClient {
  fetch: (url: string, options: RequestInit) => Promise<Response>;
}

interface Options {
  data?: object;
  query?: object;
  headers?: object;
}

export type MakeCallPromise<T> = Promise<{ status: number; data: T }>;

export type MakeCall = <T>(
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
  pathname: string,
  options?: Options,
) => MakeCallPromise<T>;

type CreateMakeCall = (fetchClient: FetchClient) => MakeCall;

const createMakeCall: CreateMakeCall = fetchClient => (
  method,
  pathname,
  options = {},
) => {
  const { data = {}, query = {}, headers = {} } = options;

  let body;

  const hasData = ['POST', 'PUT', 'PATCH'].includes(method) && data;

  if (
    hasData &&
    headers['Content-Type'] &&
    headers['Content-Type'].includes('multipart/form-data')
  ) {
    body = prepareFormData(data);
    // This is a work-around for more details please check
    // - https://stackoverflow.com/q/39280438/1132405#comment73780091_39281156
    // - https://stackoverflow.com/a/33809474/1132405
    delete headers['Content-Type']; // eslint-disable-line no-param-reassign
  } else if (hasData) {
    body = JSON.stringify(data);
    headers['Content-Type'] = 'application/json'; // eslint-disable-line no-param-reassign
  } else {
    headers['Content-Type'] = 'application/json'; // eslint-disable-line no-param-reassign
  }

  return fetchClient
    .fetch(`${pathname}${buildParams(query)}`, {
      method,
      body,
      headers: {
        Accept: 'application/json',
        ...headers,
      },
    })
    .then(handleApiV2Response)
    .catch((error: ApiError) => {
      throw new RequestError(error.status, error.message, error);
    });
};

export default createMakeCall;
